import { render, staticRenderFns } from "./ClipboardSvg.vue?vue&type=template&id=37985559&"
import script from "./ClipboardSvg.vue?vue&type=script&lang=ts&"
export * from "./ClipboardSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports